import { useTranslation } from 'react-i18next'

import { Button } from '@ui/components/Button'

import { useWindowResize } from '@utils/domUtils'

import { useFormatNumber } from '@hooks/useFormatNumber'

import { Box } from '@shared/components/Box'

import { getStepDecimals } from '../utils/helpers'

interface MarketWidgetBottomProps {
  buyPrice?: number | null
  sellPrice?: number | null
  priceIncrement?: number | null
  onBuy: () => void
  onSell: () => void
}

const PRICE_PLACEHOLDER = '—'

export const MarketWidgetBottom: React.FC<MarketWidgetBottomProps> = ({
  buyPrice,
  sellPrice,
  priceIncrement,
  onBuy,
  onSell,
}) => {
  const { t } = useTranslation()
  const { formatNumber } = useFormatNumber()
  const isMobile = useWindowResize()
  const fractionDigits = getStepDecimals(priceIncrement)
  const formatPrice = (p: number | null | undefined) =>
    p != null
      ? formatNumber(p, { minDecimalPlaces: fractionDigits, maxDecimalPlaces: fractionDigits })
      : PRICE_PLACEHOLDER

  const sellLabel = `${t('Instruments.Sell')} ${formatPrice(sellPrice)}`
  const buyLabel = `${t('Instruments.Buy')} ${formatPrice(buyPrice)}`

  return (
    <Box
      flex
      align='center'
      justify='center'
      pt='x16'
      pb={isMobile ? 'x0' : 'x16'}
      px={isMobile ? undefined : 'x16'}
      gap='x8'
    >
      <Button.Danger size='sm' fullWidth onClick={onSell} tabularNums>
        {sellLabel}
      </Button.Danger>
      <Button.Success size='sm' fullWidth onClick={onBuy} tabularNums>
        {buyLabel}
      </Button.Success>
    </Box>
  )
}
